

export type EmployerValue = {
  currentEmployer: string,
  currentEmployerContact: string,
  yearsAtCurrentEmployer: number,
  monthsAtCurrentEmployer: number,
  previousEmployer?: string | null,
  previousEmployerContact?: string | null,
} | null;
